/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface ComplCertificateDownloadServicePayload {
    careerId: string;
}

export interface ComplCertificateDownloadResponse {
    fileData: string;
    contentType: string;
}

class ComplCertificateDownloadService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "complCertificateDownload");
    }

    public async complCertificateDownload(
        payload: ComplCertificateDownloadServicePayload,
        resolved: (json: ComplCertificateDownloadResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as ComplCertificateDownloadResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default ComplCertificateDownloadService;
